import React, { useState } from 'react';
import Hero from '../Components/portfolio/Hero';
import About from '../Components/portfolio/About';
import Experience from '../Components/portfolio/Experience';
import Projects from '../Components/portfolio/Projects';
import Blogs from '../Components/portfolio/Blogs';
import Contact from '../Components/portfolio/Contact';
import Education from '../Components/portfolio/Education';
import Skills from '../Components/portfolio/Skills';
import Chatbot from '../Components/portfolio/Chatbot';
import StoryMode from '../Components/portfolio/StoryMode';

export default function PortfolioPage() {
  const [storyActive, setStoryActive] = useState(true);

  return (
    <>
      {storyActive && (
        <StoryMode onComplete={() => setStoryActive(false)} />
      )}

      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <Hero onReplayStory={() => setStoryActive(true)} />
        <About />
        <Experience />
        <Education />
        <Projects />
        <Blogs />
        <Skills />
        <Contact />
        <Chatbot />
      </div>
    </>
  );
}